import { render, staticRenderFns } from "./ReqTrasladoTableComponent.vue?vue&type=template&id=dd6dbd52&"
import script from "./ReqTrasladoTableComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports